import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "toolbar-page-cnt"
};
const _hoisted_2 = {
  class: "tb-pg-toolbar"
};
const _hoisted_3 = {
  key: 0,
  class: "table-page-header"
};
const _hoisted_4 = {
  class: "tb-pg-content"
};
const _hoisted_5 = {
  key: 0,
  class: "x-body-error"
};
const _hoisted_6 = {
  key: 1,
  class: "x-body-loading"
};
const _hoisted_7 = {
  class: "toolbar-page-body"
};
import { computed, toRefs } from 'vue';
import { XToolbar } from '@/components';
import { CloseCircleOutlined } from '@ant-design/icons-vue';
const __default__ = {
  name: 'XToolbarLayout'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    toolbar: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: ''
    }
  },
  emits: ['toolbar-item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // eslint-disable-next-line
    const {
      loading,
      error
    } = toRefs(props);
    const emit = __emit;
    const toolbarItems = computed(() => props.toolbar);
    const handleToolbarItemClick = item => {
      emit('toolbar-item-click', item);
    };
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "toolbar", {}, () => [_createVNode(_unref(XToolbar), {
        items: toolbarItems.value,
        onItemClick: handleToolbarItemClick
      }, null, 8, ["items"])])]), _ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_unref(error) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(CloseCircleOutlined)), _createElementVNode("span", null, "出错了:" + _toDisplayString(_unref(error)), 1)])) : _unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_a_spin, {
        size: "large"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "default")])])]);
    };
  }
});